import React, { useState, useMemo } from "react";
import { useGroupChatContext } from "../../../../../context/groupchatContext";
import { useGetLocationsQuery, useGetNurseLocationsQuery, useGetProvidersQuery } from "../../../../../services/location_services";
import { locationsParams, providersParams } from "./locations_constants";
import CareCoSettingsDialogue from "./CareCoSettingsDialogue";
import LocationsListing from "./LocationListing";

function Locations() {
  const { authData } = useGroupChatContext();
  const isProvider = !!authData?.is_provider;

  // triggers - skip based on user type
  const { data: locationsData, isLoading: locationsLoading, refetch: refetchLocations } = useGetLocationsQuery(locationsParams, { skip: !isProvider });
  const { data: nurseLocationsData, isLoading: nurseLocationsLoading, refetch: refetchNurseLocations } = useGetNurseLocationsQuery(locationsParams, { skip: isProvider });
  const { data: providersData, isLoading: providersLoading } = useGetProvidersQuery(providersParams, { skip: !isProvider });

  // states
  const [selectedLocation, setSelectedLocation] = useState({
    showSettingsDialogue: false,
    currentLocation: {},
    settingsType: "",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const locationsList = isProvider ? (locationsData?.data || []) : (nurseLocationsData?.data || []);
  const refetchLocationsList = isProvider ? refetchLocations : refetchNurseLocations;

  const filteredLocations = useMemo(() => {
    if (!searchTerm.trim()) {
      return locationsList;
    }
    const searchLower = searchTerm.toLowerCase();
    return locationsList.filter((location) =>
      location.name?.toLowerCase().includes(searchLower)
    );
  }, [locationsList, searchTerm]);

  return (
    <div>
      {selectedLocation?.showSettingsDialogue ? 
        <CareCoSettingsDialogue
          refetchLocations={refetchLocationsList}
          setSelectedLocation={setSelectedLocation}
          selectedLocation={selectedLocation || {}}
          providersData={providersData || []}
          locationsData={locationsList}
        /> 
      : null}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-3 sm:gap-4 px-3 sm:px-4 py-3 sm:py-0 sm:h-[55px] shadow-lg bg-white">
        <p className="text-sm sm:text-[14px] font-bold text-gray-800 shrink-0">Locations</p>
        <input
          type="text"
          placeholder="Search by location name"
          className="w-full sm:w-64 md:w-[300px] h-10 rounded-lg border border-gray-200 bg-gray-50/50 px-3 text-sm placeholder:text-gray-400 focus:border-[#3cc9b0] focus:ring-2 focus:ring-[#3cc9b0]/20 focus:outline-none transition-colors"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label="Search locations by name"
        />
      </div>
      <LocationsListing
        locations={filteredLocations}
        locationsLoading={(isProvider ? locationsLoading : nurseLocationsLoading) || false}
        setSelectedLocation={setSelectedLocation}
      />
    </div>
  );
}

export default Locations;
